import { createMuiTheme } from "@material-ui/core";
import { globalStyles } from "./globalStyles";

const theme = createMuiTheme({
    typography: {
        fontFamily: `Inter, sans-serif`,
        fontSize: 16,
    },
    palette: {
        primary: {
            main: globalStyles.palette.primaryColor.main,
        },
        secondary: {
            main: globalStyles.palette.secondaryColor.main,
        },
        grey: {
            main: '#262837',
            light: '#EBEBEB'
        },
        background: {
            default: '#fff'
        },
        text: {
            primary: '#262837',
        }
    },
    link: {
        textDecorationStyle: 'none'
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        }
    }
});

theme.overrides = {
    MuiPaper: {
        root: {
            minHeight: 520
        },
        elevation1: {
            boxShadow: 'none'
        }
    },
    MuiLink: {
        root: {
            color: theme.palette.secondary.main,
            fontWeight: 400,
        },
        underlineHover: {
            textDecoration: 'underline',
            "&:hover": {
                textDecorationThickness: '2px',
            }
        }
    },
    MuiButton: {
        label: {
            zIndex: 1,
        },
        contained: {
            position: 'relative',
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.25,
            border: 'none',
            borderRadius: 7,
            boxShadow: '0 2px 4px 0 rgb(0 0 0 / 50%)',
            padding: '11px 30px',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
        }
    },
    MuiInput: {
        underline: {
            '&:before': {
                borderBottom: `2px solid ${theme.palette.grey.light}`,
                borderBottomColor: theme.palette.grey.light,
            },
            '&:after': {
                borderBottomColor: theme.palette.grey.light,
            },
            '&:hover:not($disabled):before': {
                borderBottomColor: theme.palette.secondary.main,
            },
        },
        root: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiInputLabel: {
        animated: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiTableCell: {
        root: {
            borderBottom: `3px solid ${theme.palette.grey.light}}`,
            padding: 8,
            height: 48,
            fontWeight: 300,
        },
    },
    MuiTableRow: {
        root: {
            '& > th': {
                fontWeight: 800,
                fontSize: 16,
            },
            '& > td:nth-child(1)': {
                width: '17%',
                minWidth: 100,
            },
            '& > td:nth-child(2)': {
                width: '51%',
                fontSize: theme.typography.fontSize,
            },
            '& > td:nth-child(3)': {
                width: '16%'
            },
            '& > td:nth-child(4)': {
                width: '16%'
            }
        },
        head: {
            borderBottom: `2px solid ${theme.palette.secondary.main}`,
        },
    },
    MuiMenuItem: {
        root: {
            fontSize: theme.typography.fontSize,
        }
    },
};

export default theme;
